import { render, staticRenderFns } from "./aPricingStrategyCardStrategyRule.vue?vue&type=template&id=53317c1c&scoped=true"
import script from "./aPricingStrategyCardStrategyRule.vue?vue&type=script&lang=js"
export * from "./aPricingStrategyCardStrategyRule.vue?vue&type=script&lang=js"
import style0 from "./aPricingStrategyCardStrategyRule.vue?vue&type=style&index=0&id=53317c1c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53317c1c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardActions } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VBtn,VCard,VCardActions,VCardText,VCardTitle,VDialog,VIcon})
